import type { AppState } from "../state/actions.ts";
import type { TelegramDocument } from "../types/document.ts";

function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function exportJson(state: AppState): void {
  const doc: TelegramDocument = {
    version: 1,
    text: { html: state.textHtml, style: state.textStyle },
    canvas: { width: state.canvasWidth, height: state.canvasHeight },
    objects: state.objects,
  };
  const blob = new Blob([JSON.stringify(doc, null, 2)], { type: "application/json" });
  triggerDownload(blob, "telegram.json");
}
